import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import QR from "../../img/QR.jpg";
import { useParams } from "react-router-dom";
import { GetSelectedServerInfo } from "../../Api/Panel/GetSelectedServerInfo";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { SendDepositInfo } from "../../Api/SendDepositInfo";
import { useAuth } from "../../Context/AuthContext";

export default function GetServer() {
  const { serverID } = useParams();
  const { userID } = useAuth();

  const [isCopy, setIsCopy] = useState(false);
  const [serverDataInfo, setServerDataInfo] = useState({});
  const GET = async () => {
    const { data } = await GetSelectedServerInfo(serverID);
    setServerDataInfo(data);
  };

  useEffect(() => {
    GET();
    //eslint-disable-next-line
  }, [serverID]);

  useEffect(() => {
    if (isCopy) {
      setTimeout(() => {
        setIsCopy(false);
      }, 2500);
    }
  }, [isCopy]);

  const { handleSubmit, handleChange, handleBlur, touched, values, errors } = useFormik({
    initialValues: {
      TxID: "",
    },
    validationSchema: Yup.object({
      TxID: Yup.string().min(10, "transaction address short").required("Transaction Address required"),
    }),
    onSubmit: async (values) => {
      const hazirla = {
        IsTrue: false,
        ServerLevel: serverID,
        ...values,
        userID,
        Value: serverDataInfo.bigPrice,
        TxDate: Date.now(),
      };

      const { data } = await SendDepositInfo(hazirla);
      if (data.status) {
        Swal.fire("Transaction Successful!", `${data.msg}`, "success");
      } else {
        Swal.fire("Transaction Failed!", `${data.msg}`, "error");
      }
    },
  });

  return (
    <>
      {serverDataInfo !== null ? (
        <div className="flex col-span-4 xl:col-span-4 shadow-md border rounded-lg">
          <div className="py-8 px-5 w-full space-y-7">
            <h2 className="text-xl lg:text-2xl text-center pb-6 w-full font-medium leading-6 text-gray-900">
              Level {serverDataInfo?.Sid} Server
            </h2>

            <div className="overflow-hidden bg-white shadow-md sm:rounded-lg">
              <div className="px-4 py-5 sm:px-6">
                <h3 className="text-lg font-medium leading-6 text-gray-900">Server Information</h3>
                <p className="mt-1 max-w-2xl text-sm text-gray-500">Server details and application.</p>
              </div>
              <div className="border-t border-gray-200">
                <dl>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Server Name</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{serverDataInfo?.title}</dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">time interval</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">30 Day</dd>
                  </div>
                  <div className="bg-gray-50 px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">Daily income / Server Price</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">
                      {serverDataInfo?.DailyPrice} / {serverDataInfo?.bigPrice}
                    </dd>
                  </div>
                  <div className="bg-white px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <dt className="text-sm font-medium text-gray-500">About Server</dt>
                    <dd className="mt-1 text-sm text-gray-900 sm:col-span-2 sm:mt-0">{serverDataInfo?.About}</dd>
                  </div>
                </dl>
              </div>
            </div>
            <div className="overflow-hidden bg-white shadow-md sm:rounded-lg">
              <div className="px-4 py-5 sm:px-6">
                <h3 className="text-lg font-medium leading-6 text-gray-900">Payment Information</h3>
              </div>
              <div className="border-t border-gray-200">
                <dl>
                  <div>
                    <div className="bg-white px-4 py-5 mx-auto w-1/3">
                      <img src={QR} alt="qr" />
                    </div>
                    <div className="bg-white px-4 py-5">
                      <p className="text-sm text-gray-900 text-center lg:text-md">
                        Destination Address: THQcPTDavmmJZYYL7RfKtsD2B7QtdZrKLE
                        <br />
                        Network: TRC20
                        <br />
                        <button
                          className="mx-auto mt-2 w-2/5 cursor-pointer text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-[#3742fa] p-2bg-[#3742fa] hover:bg-[#5352ed] p-2 focus:ring-primary-900"
                          onClick={() => {
                            navigator.clipboard.writeText("THQcPTDavmmJZYYL7RfKtsD2B7QtdZrKLE");
                            setIsCopy(true);
                          }}
                        >
                          Copy Wallet Address
                        </button>
                        <br />
                        <br />
                        {isCopy ? <span className="text-green-500">Copied.</span> : null}
                      </p>
                    </div>
                  </div>

                  <div className="bg-gray-50 px-4 py-5 sm:px-6">
                    <form onSubmit={handleSubmit}>
                      <div className="mb-6">
                        <dt className="text-sm font-medium text-gray-500">Your Sent Transaction Address</dt>
                        <input
                          onChange={handleChange}
                          value={values.TxID}
                          onBlur={handleBlur}
                          name="TxID"
                          type="text"
                          className="form-control block w-full px-4 py-2 text-md font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                          placeholder="Transaction Address"
                        />
                        {touched.TxID && errors.TxID && <span className="text-red-500 py-2">{errors.TxID}</span>}

                        <div className="px-4 py-5">
                          <p className="text-sm text-gray-900 text-center lg:text-md">
                            After sending the specified amount, send us the sent transaction information.
                            <br />
                            After checking and reviewing, your server will be activated within 30 minutes.
                          </p>
                        </div>
                        <div className="flex w-full">
                          <button
                            type="submit"
                            className="mx-auto mt-2 w-2/5 cursor-pointer text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-200 font-medium rounded-lg text-sm px-5 py-2.5 text-center bg-[#3742fa] p-2bg-[#3742fa] hover:bg-[#5352ed] p-2 focus:ring-primary-900"
                          >
                            Send Deposit Information
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <Link to="/pagenotfound" />
      )}
    </>
  );
}
